import React from "react";

function EyeOpenIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="35"
      height="33"
      viewBox="0 0 35 33"
    >
      <g
        id="Group_27870"
        data-name="Group 27870"
        transform="translate(7018 24407)"
      >
        <rect
          id="Rectangle_11971"
          data-name="Rectangle 11971"
          width="35"
          height="33"
          transform="translate(-7018 -24407)"
          fill="#596970"
          opacity="0"
        />
        <path
          id="Path_18887"
          data-name="Path 18887"
          d="M1.182,12.842a12.031,12.031,0,0,1,23.661,0,12.031,12.031,0,0,1-23.661,0Zm11.83,5.468a5.468,5.468,0,1,0-5.468-5.468A5.468,5.468,0,0,0,13.012,18.309Zm0-2.187a3.281,3.281,0,1,1,3.281-3.281A3.281,3.281,0,0,1,13.012,16.122Z"
          transform="translate(-7013.182 -24403)"
          fill="#596970"
        />
      </g>
    </svg>
  );
}

export default EyeOpenIcon;
